/* voltage: max quantity limit, PDP + cart */
(function () {
  "use strict";

  var cfg = window.VoltageMaxQty || {};
  var TOKEN = (cfg.token || "").trim();
  var ROOT = cfg.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var SF_API_VERSION = "2024-10";

  /* cart state */
  var cartItems = [];
  function cartUrl() { return ROOT.replace(/\/$/, "") + "/cart.js"; }
  function loadCart() {
    return fetch(cartUrl(), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartItems = (c && c.items) || []; return cartItems; })
      .catch(function () { cartItems = []; return cartItems; });
  }
  function cartQtyForVariant(vid) {
    var q = 0, k = String(vid);
    for (var i = 0; i < cartItems.length; i++) if (String(cartItems[i].variant_id) === k) q += cartItems[i].quantity;
    return q;
  }

  /* lock helpers */
  // not using `disabled`, which the theme owns for sold-out state
  function lockAtc(btn, label, on) {
    if (!btn) return;
    if (on) {
      btn.classList.add("voltage-maxed");
      btn.setAttribute("aria-disabled", "true");
      var lab = btn.querySelector(".voltage-max-label");
      if (!lab) { lab = document.createElement("span"); lab.className = "voltage-max-label"; btn.appendChild(lab); }
      lab.textContent = label;
    } else {
      btn.classList.remove("voltage-maxed");
      btn.removeAttribute("aria-disabled");
      var ex = btn.querySelector(".voltage-max-label");
      if (ex) ex.remove();
    }
  }
  // cart uses readonly, not disabled: disabled inputs aren't submitted, which breaks minus
  function disableQty(comp, on, isCart) {
    if (!comp) return;
    comp.classList.toggle("voltage-maxed", on);
    var input = comp.querySelector(".quantity-input");
    var plus = comp.querySelector(".quantity-plus");
    var minus = comp.querySelector(".quantity-minus");
    if (plus) plus.disabled = on;
    if (isCart) {
      if (input) { input.readOnly = on; input.disabled = false; }
      if (minus) minus.disabled = false;
    } else {
      if (input) { input.disabled = on; input.readOnly = on; }
      if (minus) minus.disabled = on;
    }
  }
  // remaining = null removes our cap
  function capQty(comp, remaining) {
    var input = comp.querySelector(".quantity-input");
    if (!input) return;
    if (remaining == null) {
      if (input.dataset.vmqCapped) { input.removeAttribute("max"); delete input.dataset.vmqCapped; }
      return;
    }
    input.setAttribute("max", String(remaining));
    input.dataset.vmqCapped = "1";
    var v = parseInt(input.value, 10);
    if (!isNaN(v) && v > remaining) input.value = String(remaining);
    try { input.dispatchEvent(new Event("input", { bubbles: true })); } catch (e) {}
  }

  /* PDP */
  var controllers = [];

  class VoltageMaxQty extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.dataset.variants || "{}"); } catch (e) { this.variants = {}; }
      this.msgTpl = this.dataset.message || "Max [max] per customer";
      this.currentVariant = this.readVariant();
      var self = this;
      this._onVariant = function (e) {
        var v = e.detail && e.detail.variant;
        if (v && v.id) { self.currentVariant = String(v.id); self.evaluate(); }
      };
      document.addEventListener("variant:changed", this._onVariant);
      if (controllers.indexOf(this) === -1) controllers.push(this);
      refresh();
    }
    disconnectedCallback() {
      document.removeEventListener("variant:changed", this._onVariant);
      var i = controllers.indexOf(this);
      if (i !== -1) controllers.splice(i, 1);
    }
    // product form sits inside buy-buttons, not around us, so scope to the section
    scope() {
      return this.closest('[id^="shopify-section-"]') ||
        document.getElementById("shopify-section-" + this.dataset.sectionId) ||
        document;
    }
    readVariant() {
      var form = document.querySelector('product-form-component[data-section-id="' + this.dataset.sectionId + '"]');
      var input = (form || this.scope()).querySelector('[name="id"]');
      return input ? String(input.value) : null;
    }
    evaluate() {
      if (!this.currentVariant) this.currentVariant = this.readVariant();
      var max = this.variants[this.currentVariant];
      var scope = this.scope();
      var remaining = max ? Math.max(0, max - cartQtyForVariant(this.currentVariant)) : null;
      var maxed = remaining === 0;
      var label = String(this.msgTpl).replace(/\[max\]/gi, max).replace(/\[insert-qty-here\]/gi, max);

      scope.querySelectorAll(".add-to-cart-button").forEach(function (b) { lockAtc(b, label, maxed); });
      scope.querySelectorAll('quantity-selector-component:not([data-context="cart-items"])').forEach(function (q) {
        if (maxed) {
          disableQty(q, true, false);
        } else {
          disableQty(q, false, false);
          capQty(q, remaining);
        }
      });
      // hides the sticky add-to-cart bar via CSS
      if (scope && scope.classList) scope.classList.toggle("voltage-maxqty-active", maxed);
    }
  }

  if (!customElements.get("voltage-max-qty")) customElements.define("voltage-max-qty", VoltageMaxQty);

  /* cart, max looked up via Storefront API */
  var maxCache = {}; // variantId: number or null
  function lookupMaxes(vids) {
    if (!TOKEN) return Promise.resolve();
    var need = [];
    for (var i = 0; i < vids.length; i++) { var v = String(vids[i]); if (!(v in maxCache) && need.indexOf(v) === -1) need.push(v); }
    if (!need.length) return Promise.resolve();
    var gids = need.map(function (v) { return "gid://shopify/ProductVariant/" + v; });
    var query = "query($ids:[ID!]!){ nodes(ids:$ids){ ... on ProductVariant { id metafield(namespace:\"custom\",key:\"max_quantity\"){ value } } } }";
    return fetch(ROOT.replace(/\/$/, "") + "/api/" + SF_API_VERSION + "/graphql.json", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": TOKEN },
      body: JSON.stringify({ query: query, variables: { ids: gids } })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var nodes = (d && d.data && d.data.nodes) || [];
        nodes.forEach(function (n) {
          if (!n || !n.id) return;
          var idNum = n.id.split("/").pop();
          var mv = n.metafield && n.metafield.value;
          maxCache[idNum] = mv ? parseInt(mv, 10) : null;
        });
        need.forEach(function (v) { if (!(v in maxCache)) maxCache[v] = null; });
      })
      .catch(function () { need.forEach(function (v) { maxCache[v] = null; }); });
  }

  function enforceCart() {
    var selectors = document.querySelectorAll('quantity-selector-component[data-context="cart-items"]');
    if (!selectors.length) return;
    var vids = cartItems.map(function (i) { return i.variant_id; });
    lookupMaxes(vids).then(function () {
      selectors.forEach(function (sel) {
        var input = sel.querySelector("[data-cart-line]");
        var line = input ? parseInt(input.getAttribute("data-cart-line"), 10) : 0;
        var item = line ? cartItems[line - 1] : null;
        var max = item ? maxCache[String(item.variant_id)] : null;
        var maxed = !!max && item.quantity >= max;
        disableQty(sel, maxed, true);
        if (maxed && input) input.setAttribute("max", max);
      });
    });
  }

  /* block clicks on locked controls */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var atc = t.closest(".add-to-cart-button.voltage-maxed");
    var plus = t.closest(".quantity-plus");
    var inMaxed = plus && plus.closest("quantity-selector-component.voltage-maxed");
    if (atc || inMaxed) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* refresh */
  function applyAndEvaluate() {
    for (var i = 0; i < controllers.length; i++) controllers[i].evaluate();
    enforceCart();
  }
  function refresh() { return loadCart().then(applyAndEvaluate); }

  // fires after the cart re-renders and carries the full cart
  document.addEventListener("cart:updated", function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && cart.items) { cartItems = cart.items; applyAndEvaluate(); }
    else refresh();
  });

  // voltage: skip the startup cart fetch when there is nothing to lock
  function cartLooksEmpty() {
    var bubble = document.querySelector("cart-count");
    return !bubble || bubble.classList.contains("hidden");
  }
  function init() {
    if (controllers.length === 0 && cartLooksEmpty()) return;
    refresh();
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", refresh);
})();
